export const resolveHistoryCursor = (messagesList, now = () => new Date().toISOString()) => {
  const oldestMessage = messagesList && messagesList[0];
  if (oldestMessage && oldestMessage.createdAt) return oldestMessage.createdAt;
  return now();
};
